let protocol = 'https://';
let server = 'dev.skinreader.cn'; // 开发服务器IP

// let protocol = 'https://';
// let server = 'cloud.skinreader.cn'; // 正式服务器IP

// let protocol = 'http://';
// let server = '127.0.0.1:7001'; // 本地测试服务器IP

// let protocol = 'http://';
// let server = '192.168.31.69:7001'; // 本地测试服务器IP
// let server = '192.168.43.200:7001'; // 本地测试服务器IP

if (process.env.NODE_ENV === 'production') {
  protocol = window.location.protocol + '//';
  server = window.location.host.replace(/:\d+/, '') + (window.location.port ? `:${window.location.port}` : '');
}

const api = {
  // 服务器地址
  server: protocol + server,
  knowledgeUrl: protocol + server + '/knowledge',
  // 皮肤病知识库
  knowledge: protocol + server + '/knowledge/index.json',
  // 知识库-字典结构
  wordbook: protocol + server + '/knowledge/dic.json',
  event: protocol + server + '/event',
  // 医生自定义报告模板
  template: protocol + server + '/templates/',
  // 皮肤病知识库病名id简易数据
  knowledgeDic: protocol + server + '/knowledge/dic.json',
  // 影像管理缩略图请求
  imageSrcPrefixThumbnails: protocol + server + '/skin_images/thumbnails/',
  // 影像管理大图请求
  imageSrcPrefix: protocol + server + '/skin_images/',
  pdfmake:protocol + server +"/pdf",
  // 获取医生头像
  doctor_header: protocol + server + '/doctor_images/',
  // 住院图片缩略图地址
  hospitalization_imagesThumbnails: protocol + server + '/hospitalization_images/thumbnails/',
  // 住院图片大图地址
  hospitalization_images: protocol + server + '/hospitalization_images/',
  // 导出手术预约excel
  export_excel: protocol + server + '/exportexcel',
  // 导出美容预约excel
  export_cosmet_reg_excel: protocol + server + '/exportCosmetRegExcel',
  // 美容图片路径
  cosmetology_images: protocol + server + '/cosmetology_images/',
  cosmetology_imagesThumbnails: protocol + server + '/cosmetology_images/thumbnails/',
};

export default api;
